import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"100\" cy=\"100\" r=\"64\"></circle><circle cx=\"100\" cy=\"100\" r=\"64\"></circle><path fill=\"none\" stroke=\"var(--mc-avatar)\" stroke-width=\"4\" d=\"M60 100a50 60 0 0 1-30-30\" opacity=\".8\"></path><circle cx=\"80\" cy=\"90\" r=\"6\" fill=\"var(--mc-avatar)\"></circle><circle cx=\"120\" cy=\"90\" r=\"6\" fill=\"var(--mc-avatar)\"></circle><path fill=\"none\" stroke=\"var(--mc-avatar)\" stroke-linecap=\"round\" stroke-width=\"5\" d=\"M78 122q22 16 44 0\"></path>", 6)
  ]))]))
}
export default { render: render }